// Anglar
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// Layout Directives
import { ContentAnimateDirective, HeaderDirective, MenuDirective, StickyDirective } from './_base/layout';
// Metronic Pipes
// Metornic Services
import { FirstLetterPipe, GetObjectPipe, JoinPipe, OffcanvasDirective, SafePipe, ScrollTopDirective, TabClickEventDirective, TimeElapsedPipe, ToggleDirective } from './_base/metronic';
import { AutoResizeFontDirective } from './_base/layout/directives/auto-resize-font.directive';
import { ResizableDirective } from './_base/layout/directives/resizable.directive';
import { CustomDatePipe } from './_base/metronic/pipes/custom-date.pipe';
import { ShortCurrencyPipe } from './_base/metronic/pipes/short-currency.pipe';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { CommentCountPipe } from './_base/metronic/pipes/comment-count.pipe';

@NgModule({
	imports: [CommonModule, MatSnackBarModule],
	declarations: [
		// directives
		ScrollTopDirective,
		HeaderDirective,
		OffcanvasDirective,
		ToggleDirective,
		MenuDirective,
		TabClickEventDirective,
		// SparklineChartDirective,
		ContentAnimateDirective,
		AutoResizeFontDirective,
		ResizableDirective,
		StickyDirective,
		// pipes
		TimeElapsedPipe,
		JoinPipe,
		GetObjectPipe,
		SafePipe,
		FirstLetterPipe,
		CustomDatePipe,
		ShortCurrencyPipe,
		CommentCountPipe
	],
	exports: [
		// directives
		ScrollTopDirective,
		HeaderDirective,
		OffcanvasDirective,
		ToggleDirective,
		MenuDirective,
		TabClickEventDirective,
		// SparklineChartDirective,
		ContentAnimateDirective,
		AutoResizeFontDirective,
		ResizableDirective,
		StickyDirective,
		// pipes
		TimeElapsedPipe,
		JoinPipe,
		GetObjectPipe,
		SafePipe,
		FirstLetterPipe,
		CustomDatePipe,
		ShortCurrencyPipe,
		CommentCountPipe
	]
})
export class CoreModule {
}
